import { getRoles } from "../constants/constants";
const check = (accessRules: any, role: any, action: any, data: any) => {
  let rules = getRoles(role, accessRules);
  if (!rules) {
    return false;
  }
  const staticPermissions = canPerformStatic(action, rules.static);
  if (staticPermissions && staticPermissions.enabled) {
    return true;
  }
  return false;
};
const canPerformStatic = (action: any, rules: any) => {
  let actions = rules.filter((ruleItem: any) => {
    return ruleItem.permission === action;
  });
  return actions.length > 0 ? actions[0] : null;
};
const HasPermission = (props: any) => {
  if (!props.accessRules) {
    return props.no();
  }
  return check(props.accessRules, props.role, props.perform, props.data)
    ? props.yes()
    : props.no();
};

HasPermission.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default HasPermission;
